/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, Sep 08, 2016
 * For information or permission request, email info@aetonixsystems.com
 */



var Model = require("../types/Model.js");
var xtend = require("xtend");
// TODO: Be more smart with added and removed events

/**
 * Keeps track of the manage groups that the current person is a part of
 * @type {Model}
 */
module.exports = Model({
	name: "managegroups",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_ready: false,

	refresh: refresh,
});

/**
 * Adds listeners for changes in the user list, changes in the people store, and fetches the initial state
 * @return {Promise} Resolves to the initial state
 */
function init() {
	this._ready = false;

	this.push([]);
}

/**
 * Clears extra data
 * @return {Promise} Resolves after everything is done.
 */
function uninit() {}

function listeners() {
	return {
		"loadchecker:ready": initial_load,
		"mqtt:$/managegroup/added": refresh,
		"mqtt:$/managegroup/removed": handle_removed,
		"connectivity:online": refresh,
	};
}

function handle_removed(data) {
	var id = data.manageGroup;

	const oldSize = this.data.length;
	const filtered = this.data.filter((existing) => {
		return existing._id !== id;
	});

	if(filtered.length !== oldSize) this.push(filtered);
}

function initial_load() {
	this._ready = true;
	this.refresh();
}

/**
 * Refreshes the list of manage groups
 */
function refresh() {
	if(!this._ready) return Promise.resolve([]);
	return this.api.manage.managegroup.list()
		.then(this.push.bind(this));
}
